/** Links shared by every deployment. Not environment settings: there is no dev/prod variant of the public docs. */

/** Public product documentation. */
export const DOCS_URL = 'https://docs.westyx.dev';
